import { GoArrowLeft  } from "react-icons/go";
import { CiLaptop ,CiGrid2H,CiRead ,CiCircleCheck    } from "react-icons/ci";
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
export const Urbanistic = () => {


    return (
        <div>
            <div className="relative isolate overflow-hidden bg-white  lg:overflow-visible lg:px-0">

                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8  lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                    <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8">
                        <div className="lg:pr-4">
                            <div className="lg:max-w-lg">
                                <a href={"/company/integrations"} className="text-sm items-center flex font-semibold text-indigo-600"><GoArrowLeft className={"h-5 w-5 mr-2"}/>Zurück</a>
                                <h1 className="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 ">
                                    Urbanistic<br/>Interaktive 3D-Stadtmodelle für Konversions- und Neubauprojekte
                                </h1>
                                <p className="mt-6 text-sm text-gray-700">
                                    Vorentwurfsplanungen mit unterschiedlichen Beteiligten darstellend bearbeiten und dies auf Basis von Xplan-Daten – das bietet die Schnittstelle zu Urbanistic.
                                    So werden Neubauprojekte und Konversionsprojekte schneller, effizienter und für alle Beteiligten klar verständlich.
                                    <br/><br/>


                                    <div>
                                        <video className="w-full" controls>
                                            <source src={`${process.env.PUBLIC_URL}/integrations/urbanistic/Datenbasierte Entscheidungen mit Urbanistic.mp4`} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>

                                    <br/><br/>Lassen Sie sich beraten! Einfach Beratung anfragen unter <a className={"underline"} href={"mailTo:dialog@xplanung24.de"}>dialog@xplanung24.de</a>

                                </p>



                            </div>
                        </div>


                    </div>
                    <div className="-mt-12 -ml-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">

                        <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/integrations/urbanistic/1.jpg`}
                            className="w-full my-4"
                        />
                        <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/integrations/urbanistic/2.jpg`}
                            className="w-full"
                        />
                    </div>

                </div>
            </div>
        </div>
    )
}
